<template>
  <v-dialog v-model="connected_company_dialog" width="640" persistent>
    <v-card class="connected-company-page-dialog" flat>
      <v-icon size="64">
        <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
          <mask id="mask0_9511_148558" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="64" height="64">
            <rect width="64" height="64" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_9511_148558)">
            <path
              d="M28.0663 44.134L46.933 25.2673L43.8663 22.2673L28.0663 38.0673L20.0663 30.0673L17.0663 33.0673L28.0663 44.134ZM31.9997 58.6673C28.3552 58.6673 24.9108 57.9673 21.6663 56.5673C18.4219 55.1673 15.5886 53.2562 13.1663 50.834C10.7441 48.4118 8.83301 45.5784 7.43301 42.334C6.03301 39.0895 5.33301 35.6451 5.33301 32.0006C5.33301 28.3118 6.03301 24.8451 7.43301 21.6006C8.83301 18.3562 10.7441 15.534 13.1663 13.134C15.5886 10.734 18.4219 8.83398 21.6663 7.43398C24.9108 6.03398 28.3552 5.33398 31.9997 5.33398C35.6886 5.33398 39.1552 6.03398 42.3997 7.43398C45.6441 8.83398 48.4663 10.734 50.8663 13.134C53.2663 15.534 55.1663 18.3562 56.5663 21.6006C57.9663 24.8451 58.6663 28.3118 58.6663 32.0006C58.6663 35.6451 57.9663 39.0895 56.5663 42.334C55.1663 45.5784 53.2663 48.4118 50.8663 50.834C48.4663 53.2562 45.6441 55.1673 42.3997 56.5673C39.1552 57.9673 35.6886 58.6673 31.9997 58.6673Z"
              fill="#70CC14"
            />
          </g>
        </svg>
      </v-icon>

      <h3 class="text-center">{{ $t('je-bedrijfspagina-is-succesvol-gekoppeld') }}</h3>
      <p class="text-center">{{ $t('we-hebben-zojuist-een-bedrijfspagina-aan-jouw-account-gekoppeld-boven-in-de-navigatiebalk-kun-je-van-bedrijfspagina-wisselen') }}</p>
      <v-btn color="var(--company-primary)" class=" btn text-white" @click="$emit('close-dialog')">{{ $t('ok') }}</v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      connected_company_dialog: true,
    };
  },
};
</script>
